var render = function render(_c,_vm){return _c('div',{staticClass:"bg-white shadow rounded mb-12"},[(_vm.props.title)?_c('h4',{staticClass:"text-lg border-b-2 py-4 px-4 md:px-8"},[_vm._v("\n    "+_vm._s(_vm.props.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"px-4 md:px-8 py-6"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }